import React from 'react';
import {Modal, ModalBody, ModalFooter} from 'reactstrap';
import {DATE_FORMAT} from '../../api/api.types';
import dayjs, {Dayjs} from 'dayjs';
import DatePicker, {IntervalDatePickerEvent} from '../forms/DatePicker';

interface DuplicateDeskOpeningModalProps {
  period?: string;
  isOpen: boolean;
  toggle: () => void;
  onSave: (duration: { validFrom: string; validTo: string; type: DuplicateType}) => void;
  type?: DuplicateType;
}

interface DuplicateDeskOpeningModalState {
  validFrom: string;
  validTo: string;
  isInvalid: boolean;
}

export enum DuplicateType {
  DESK_OPENING = 'DESK_OPENING',
  DESK_OPENING_EXCEPTION = 'DESK_OPENING_EXCEPTION'
}

const YEARS_FOR_DEFAULT_END_DATE = 10;

export default class DuplicateDeskOpeningModal extends React.PureComponent<DuplicateDeskOpeningModalProps, DuplicateDeskOpeningModalState> {

  readonly state = {
    validFrom: dayjs().format(DATE_FORMAT),
    validTo: dayjs().add(YEARS_FOR_DEFAULT_END_DATE, 'y').format(DATE_FORMAT),
    isInvalid: false
  };

  onSaveClick = () => {
    if (!this.state.isInvalid) {
      this.props.onSave({ validFrom: this.state.validFrom, validTo: this.state.validTo, type: this.props.type || DuplicateType.DESK_OPENING });
    }
  };

  onDateChange = (field: IntervalDatePickerEvent, date?: Dayjs) => {
    let isInvalid;
    if (!date) {
      isInvalid = true;
    } else if (field === IntervalDatePickerEvent.FROM) {
      isInvalid = dayjs(this.state.validTo).isBefore(date);
    } else {
      isInvalid = date.isBefore(dayjs(this.state.validFrom));
    }

    this.setState({
      ...this.state,
      [`valid${field.valueOf()}`]: date ? date.format(DATE_FORMAT) : undefined,
      isInvalid
    });
  };

  render() {
    return (
      <Modal style={{ minWidth: '960px' }} isOpen={this.props.isOpen} toggle={this.props.toggle} autoFocus={false}>
        <ModalBody>
          <div>
            {this.props.type === DuplicateType.DESK_OPENING && (
              <>
                <h1>{`Duplicate opening hours period ${this.props.period}`}</h1>
                <div>Duplicate opening hours period with the same weekly opening hours.</div>
              </>
            )}
            {this.props.type === DuplicateType.DESK_OPENING_EXCEPTION && (
              <>
                <h1>{`Duplicate holiday ${this.props.period}`}</h1>
                <div>Duplicate holiday with the same opening hours.</div>
              </>
            )}
          </div>
          <div className="ml-1 d-flex row align-items-center justify-content-start mt-2">
            {this.props.type === DuplicateType.DESK_OPENING && (
              <div className="mr-2 text-light">Period starting date:</div>
            )}
            {this.props.type === DuplicateType.DESK_OPENING_EXCEPTION && (
              <div className="mr-2 text-light">Date:</div>
            )}
            <div className="modal-date-picker">
              <DatePicker
                  isInvalid={this.state.isInvalid}
                  isEdit
                  date={this.state.validFrom ? dayjs(this.state.validFrom) : undefined}
                  onChange={(val) => this.onDateChange(IntervalDatePickerEvent.FROM, val)}
              />
            </div>
            {this.props.type === DuplicateType.DESK_OPENING && (
            <>
              <div className="ml-1 mr-1"> - </div>
              <div className="modal-date-picker">
                <DatePicker
                    isInvalid={this.state.isInvalid}
                    isEdit
                    date={this.state.validTo ? dayjs(this.state.validTo) : undefined}
                    onChange={(val) => this.onDateChange(IntervalDatePickerEvent.TO, val)}
                />
              </div>
            </>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <div>
            <button type="button" className="btn btn-outline-secondary mr-1" onClick={this.props.toggle}>CANCEL</button>
            <button type="button" className="btn btn-primary" onClick={() => this.onSaveClick()}>SAVE</button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}
